<template>
  <div class="container">
    <h2>{{ title }}</h2>
    <div>
      <b-table
        ref="dictionaryTable"
        small
        sticky-header
        selectable
        select-mode="single"
        striped
        hover
        :fields="fields"
        :items="dictItems"
        primary-key="key"
        selected-variant="primary"
        @row-selected="onRowSelected"
      >
        <!-- :busy="isBusy" -->
        <!-- <template slot="[item_key]" slot-scope="data">
          <template v-if="!data.rowSelected">
            {{ data.item.item_key }}
          </template>
          <template v-else>
            <b-form-input v-model="form.key" :state="validSource"></b-form-input>
          </template>
        </template> -->
        <template v-slot:cell(item_key)="data">
          <template v-if="!data.rowSelected">
            {{ data.item.item_key }}
          </template>
          <template v-else>
            <b-form-input v-model="form.key" :state="validSource"></b-form-input>
          </template>
        </template>
        <template v-slot:cell(item_value)="data">
          <template v-if="!data.rowSelected">
            {{ data.item.item_value }}
          </template>
          <template v-else>
            <b-form-input v-model="form.value" :state="validDestination"></b-form-input>
          </template>
        </template>
        <template v-slot:cell(delete)="data">
          <template v-if="!data.rowSelected">
            <b-button
              v-b-tooltip.hover
              size="sm"
              variant="danger"
              title="Delete this entry"
              @click="deleteItem(data.item)"
            >
              &times;
            </b-button>
            <!-- <b-button size="sm" @click="data.toggleDetails">
              {{ data._showDetails ? '&uarr;' : '&darr;' }}
            </b-button> -->
          </template>
          <template v-else>
            <b-button-group>
              <b-button
                size="sm"
                variant="primary"
                :disabled="!formIsValid"
                @click="saveItem(data)"
              >
                Save
              </b-button>
              <b-button size="sm" @click="closeWithoutSaving">
                Close
              </b-button>
              <!-- {{ data }} -->
            </b-button-group>
          </template>
        </template>
        <template v-slot:cell(row-details)="data">
          <b-card-group>
            <b-card title="Created">
              <b-card-text>{{ data.item.created_at }}</b-card-text>
            </b-card>
            <b-card title="Updated">
              <b-card-text>{{ data.item.updated_at }}</b-card-text>
            </b-card>
          </b-card-group>
        </template>
        <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </b-table>
    </div>
    <b-button-group>
      <b-button variant="success" :disabled="!isModified" @click="saveChanges">Apply</b-button>
      <b-button @click="addNewRow">Add</b-button>
    </b-button-group>
    <pre>
    {{ changes }}
    </pre>
  </div>
</template>

<style lang="scss" scoped>
.btn.btn-danger.btn-sm {
  margin-right: 3px;
}
</style>

<script>
import _ from 'lodash';
// import Dictionary from '../models/dictionary';

function isValidValue() {
  // if (value.length > 0) {
  //   const regex = /^[/\-_0-9a-zA-Z]*$/gm;
  //   const m = regex.exec(value);
  //   return !_.isNull(m) && m.length > 0;
  // }
  // return false;
  return true;
}

export default {
  name: 'DictionaryTable',
  props: {
    items: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      changes: {},
      addingNew: false,
      form: {
        key: '',
        value: '',
      },
    };
  },
  computed: {
    fields() {
      const vm = this;
      return [
        { key: 'item_key', label: vm.keyName, sortable: true },
        { key: 'item_value', label: vm.valueName, sortable: true },
        { key: 'delete', label: '' },
      ];
    },
    /**
     * Has the dictionary changed since we loaded it?
     * @returns bool
     */
    isModified() {
      const vm = this;
      if (!vm.changes) {
        return false;
      }
      return vm.changes.length > 0;
    },
    /**
     * Should the add new row button be shown?
     * @returns bool
     */
    addNewRowVisible() {
      const vm = this;
      if (!vm.loaded) {
        return false;
      }
      return vm.$refs.dictionaryTable.selectedRows.length < 1;
    },
    /**
     * Is the key input valid?
     * @returns bool
     */
    validSource() {
      return isValidValue(this.form.key);
    },
    /**
     * Is the value input valid?
     * @returns bool
     */
    validDestination() {
      return isValidValue(this.form.value);
    },
    /**
     * Is the form valid?
     * @returns bool
     */
    formIsValid() {
      return this.validSource && this.validDestination;
    },
    /**
     * Return an array of dictionary items to display
     * @todo rename to something more generic.
     * @returns array
     */
    dictItems() {
      const vm = this;
      const items = _.clone(vm.items);
      _.each(vm.changes, change => {
        const index = _.findIndex(items, item => {
          if (item) {
            return item.item_key === change.item_key;
          }
          return false;
        });
        switch (change.op) {
          case 'create':
            // append any new items
            // eslint-disable-next-line no-case-declarations
            const newItem = { ...change };
            _.unset(newItem, 'op');
            items.push(newItem);
            break;
          case 'update':
            // eslint-disable-next-line no-case-declarations
            // const updatedItem = { ...change };
            // _.unset(updatedItem, 'op');
            // items.push(updatedItem);
            items[index].item_value = change.item_value;
            // console.log(items[index], change.item_value);
            break;
          case 'delete':
            // remove any deleted items
            _.unset(items, index);
            break;
          default:
            break;
        }
      });
      if (vm.addingNew) {
        const emptyRow = _.mapValues(items[0], () => {
          return '';
        });
        items.push(emptyRow);
      }
      return items;
    },
  },
  async mounted() {
    const vm = this;
    vm.loaded = true;
    vm.changes = [];
  },
  methods: {
    /**
     * Set the state to open up a new item
     */
    addNewRow() {
      const vm = this;
      vm.addingNew = true;
      setTimeout(() => {
        // hacky way to bump us to the next tick, where our row will actually exist and we can select it
        vm.$refs.dictionaryTable.selectRow(vm.dictItems.length - 1);
      }, 0);
    },
    /**
     * Delete a dictionary item by item_key
     */
    deleteItem(item) {
      const vm = this;
      vm.changes.push({
        op: 'delete',
        item_key: item.item_key,
      });
    },
    /**
     * Save a new item to the dictionary
     */
    saveItem(rowData) {
      const vm = this;

      if (vm.addingNew) {
        vm.changes.push({
          op: 'create',
          item_key: vm.form.key,
          item_value: vm.form.value,
        });
        vm.addingNew = false;
      } else if (rowData.item.item_key !== vm.form.key) {
        vm.changes.push({
          op: 'delete',
          item_key: rowData.item.item_key,
        });
        vm.changes.push({
          op: 'create',
          item_key: vm.form.key,
          item_value: vm.form.value,
        });
      } else {
        vm.changes.push({
          op: 'update',
          item_key: rowData.item.item_key,
          item_value: vm.form.value,
        });
      }

      vm.$refs.dictionaryTable.clearSelected();
      vm.form.key = '';
      vm.form.value = '';
    },
    /**
     * Save the modifications to the dictionary to our API endpoint
     */
    saveChanges() {
      const vm = this;
      if (vm.changes.length > 0) {
        vm.$emit('patch', { dictionary: vm.changes });
      }
    },
    /**
     * Remove the selected row modifiers
     */
    closeWithoutSaving() {
      const vm = this;
      vm.addingNew = false;
      vm.$refs.dictionaryTable.clearSelected();
    },
    /**
     * When a row is selected, set our form models, or unset them if we're adding a new item
     */
    onRowSelected(items) {
      const vm = this;
      const item = _.get(items, '0', false);
      if (item) {
        vm.form.key = _.first(items).item_key;
        vm.form.value = _.first(items).item_value;
      } else {
        vm.form.key = '';
        vm.form.value = '';
      }
    },
  },
};
</script>
